/**
 * Who gets in, and who gets to change anything.
 *
 * These two sets had drifted apart. The menu item showed for
 * `installer-certificates-admin`, `auditor` and `admin`; the route behind it
 * admitted `internal-user` and `auditor`. So the role named after this screen
 * saw a link that led to /unauthorized, and the people who could actually open
 * it had no link to click — they reached it by pasting the URL.
 *
 * Reading is business-wide, because knowing whether an installer's tickets are
 * in date is a question anyone booking work has to answer. Changing a
 * certificate, a contact, a document or a holiday belongs to the role that
 * owns them.
 */
export const INSTALLER_READ_ROLES = ['internal-user', 'auditor'];

/**
 * Both of these are held alongside `internal-user`, so neither needs listing
 * as a read role — getting in is settled by the time this is asked.
 *
 * `auditor` is deliberately absent: it is the read-everything role and has
 * been since #568. The API enforces this too — these are the roles holding the
 * create/update/delete scopes for suppliers and their certificates.
 */
export const INSTALLER_WRITE_ROLES = ['installer-certificates-admin', 'admin'];
